import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Get farm data
export const getFarmData = async (farmId, user = 'Unknown') => {
  try {
    const response = await apiClient.get('/farm', {
      params: { farmId, user }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching farm data:', error);
    throw error;
  }
};

// Get farm images
export const getFarmImages = async (farmId, user = 'Unknown') => {
  try {
    const response = await apiClient.get('/images', {
      params: { farmId, user }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching farm images:', error);
    throw error;
  }
};

export const reportIssue = async (farmId, imageId, description, user = 'Unknown') => {
  try {
    const response = await apiClient.post('/issue', {
      farmId,
      imageId,
      description,
      user
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error reporting issue:', error);
    throw error;
  }
};